import type { ActionCard } from "@/types/actions";
import type { ActionDecisionKind, ActionHistoryEvent } from "@/types/actions";

export const ActionQueueLabels = {
	source: {
		message: "Conversa",
		appointment: "Agenda",
		financial_receipt: "Financeiro",
		clinical_milestone: "Prontuário",
		clinical_section: "Prontuário",
		clinical_manual: "Prontuário",
		clinical_exam: "Prontuário",
		person: "Cadastro",
		action_event: "Decisão da equipe",
	} satisfies Record<ActionCard["sources"][number]["kind"], string>,
	role: { medica: "médica", secretaria: "secretária", agente: "pulso" },
	waitingFor: {
		medica: "médica",
		secretaria: "secretária",
		patient: "paciente",
		external: "terceiro",
		date: "data combinada",
	} satisfies Record<NonNullable<ActionCard["waiting_for"]>, string>,
	decision: {
		complete: "concluir",
		contact: "registrar contato",
		wait: "aguardar",
		transfer: "transferir",
		resume: "voltar à fila",
		contest: "contestar",
	} satisfies Record<ActionDecisionKind, string>,
	event: {
		created: "pendência identificada",
		updated: "pendência atualizada",
		contact: "contato registrado",
		waiting: "aguardando",
		transferred: "pendência transferida",
		completed: "pendência concluída",
		contested: "pendência contestada",
		closed: "pendência encerrada",
		reopened: "retorno à fila",
	} satisfies Record<ActionHistoryEvent["type"], string>,
	error: {
		action_changed: "a pendência mudou. feche e revise a versão atual antes de decidir.",
		action_not_open: "esta pendência já foi encerrada ou transferida.",
		action_same_role: "escolha outro responsável para transferir.",
		review_date_past: "escolha uma data e hora futuras para o retorno.",
	},
};
